import { render, staticRenderFns } from "./ChangementCategorie.vue?vue&type=template&id=b45a1cfa"
import script from "./ChangementCategorie.vue?vue&type=script&lang=js"
export * from "./ChangementCategorie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports